class ReelProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.scrollbarThumb = this.querySelector('[data-reel="thumb"]');
    this.slider = this.querySelector('[data-reel="slider"]');

    this.ticking = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.slider.addEventListener('scroll', this.onScrollHandler);
  }

  onScroll(_event) {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.updateScrollBar();

        this.ticking = false;
      });

      this.ticking = true;
    }
  }

  updateScrollBar() {
    let items = this.querySelectorAll('[data-reel="item"]');

    let scrollLeft = this.slider.scrollLeft;
    let scrollWidth = this.slider.scrollWidth;
    let itemWidth = items[0].scrollWidth;

    let scrollBarThumbWidthPercent = 100 / items.length;
    let scrollBarWidthPercent = 100 - scrollBarThumbWidthPercent;

    let scrollPercent = (scrollLeft / (scrollWidth - itemWidth)) * 100;
    let scrollPercentAdjusted = scrollBarWidthPercent * (scrollPercent / 100);

    this.scrollbarThumb.style.width = scrollBarThumbWidthPercent + '%';
    this.scrollbarThumb.style.left = scrollPercentAdjusted + '%';
  }
}

customElements.define('reel-product', ReelProduct);
